var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedDebtorAccount)?_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('InvoicePaidTable',{attrs:{"debtorAccountId":_vm.selectedDebtorAccount.billingAccountId,"routeDetail":'DebtorInvoiceDetail'}})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }